<template>
    <v-card>
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
            {{callbackResponse.message}}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
                Quarter Component
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <div>
            <div>
                <div>
                    <v-row>


                        <v-col cols="9"
                               sm="4"
                               md="3"
                               xl="2"
                               v-for="title in levellist"
                               v-bind:key="title.level"
                               class="viewCard">


                            <div @click="logBtnData(title,false,title.yearName)">
                                <v-card :elevation="10"
                                        class="main-color text-center"
                                        height="150"
                                        width="300">
                                    <v-list-item link>
                                        <v-list-item-content>
                                            <v-list-item-title class="white--text subtitle-1 mt-1 pa-4">
                                                <div>
                                                    <span>{{title.reportName}}</span>
                                                </div>
                                                <div>
                                                    <span>{{title.yearName}}</span>
                                                </div>
                                                <div>
                                                    <span>{{title.level}} त्रैमाशिक {{title.message}}</span>
                                                </div>

                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-card>
                            </div>


                        </v-col>

                        <v-col cols="3" sm="4" md="3" xl="2" class="viewCard">
                            <v-row>
                                <div class="col-4"></div>
                                <div class="col-8">
                                    <v-radio-group v-model="selectedRadio" :mandatory="false" @change="updateActiveLevel">
                                        <v-radio v-for="role in activeLevellist" :key="role.level" :label="role.level + ' त्रैमाशिक '" :value="role.level" class="custom-radio"></v-radio>
                                    </v-radio-group>
                                </div>
                            </v-row>
                           
                           
                            
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <div>
            <div v-if="table && headers.length>0">
                <span v-if="isLoadedFromServer">Saving...</span>
                <span v-else @click="updateReportData">
                    <v-btn v-if="isSaveable" class="float-right mt-10" color="success" style="margin-bottom:10px">
                        Save
                    </v-btn>
                </span>
                <v-btn @click="exportTableToExcel('tblData','('+reportTitle+'_'+valueShow+')',showNextYear?YearPreviousCurrentNext.next:yearShow,reportTitle)" dark class="float-right mt-10 mr-2" color="blue darken-4" style="margin-bottom:10px">
                    Export
                </v-btn>
                <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}}  को {{reportTitle}}  </h2>


                <table class="table tbl sticky-table-header">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th rowspan="2">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, count) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, secondIndex) in colsHeaders">
                                <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">क्र सं</th>
                            <template v-for="(header,index) in headers">

                                <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                    v-if="header.groupID>0 ">

                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END-->

                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, subindex) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, innerindex) in column.subList">
                                            <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>


                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, index) in subColumns">
                                <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, interindex) in column.subList">
                                    <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>
                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <template v-for="(section,index) in rows">
                        <tr :key="'row1mk'+index">
                            <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                                <span> {{index+1}}. {{section.reportSection}}</span>
                            </td>
                        </tr>
                        <template v-for="(subSection,properindex) in section.list">
                            <tr :key="properindex+'row2lk'+index">
                                <td style="text-align:center">{{properindex+1}}</td>
                                <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                    v-for="(rowsHeader, subindex) in subSection.list">
                                    <v-text-field dense @keypress="isNumber($event)" label="Amount" outlined
                                                  v-if="rowsHeader.dataType==2" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()"></v-text-field>
                                    <v-text-field dense @keypress="isNumber($event)" label="Quantity" outlined
                                                  v-else-if="rowsHeader.dataType==4" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()"></v-text-field>
                                    <v-text-field dense @keypress="isNumber($event)" label="Quantity 1" outlined
                                                  v-else-if="rowsHeader.dataType==6" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()"></v-text-field>
                                    <v-text-field dense @keypress="isNumber($event)" label="Total" outlined
                                                  v-else-if="rowsHeader.dataType==5"
                                                  v-model="rowsHeader.amount"></v-text-field>
                                    <v-text-field dense label="Text" outlined v-else v-model="rowsHeader.value"></v-text-field>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b>कुल जम्मा</b></td>
                            <td :key="'totalindex'+index" v-for="(total,index) in totals">
                                <b v-if="total!=null">{{total.total}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>



                <table class="table tbl" id="tblData" v-show="exportTbl">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th rowspan="2">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, count) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, secondIndex) in colsHeaders">
                                <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                    v-if="header.groupID>0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, subindex) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, innerindex) in column.subList">
                                            <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, index) in subColumns">
                                <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>
                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, interindex) in column.subList">
                                    <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->
                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <template v-for="(section,index) in rows">
                        <tr :key="'row1mk'+index">
                            <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                                <span> {{index+1}}. {{section.reportSection}}</span>
                            </td>
                        </tr>
                        <template v-for="(subSection,properindex) in section.list">
                            <tr :key="properindex+'row2lk'+index">
                                <td style="text-align:center">{{properindex+1}}</td>
                                <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                <td :key="subindex+'main'+'row2col'+properindex" class="data-input" style="text-align:center"
                                    v-for="(rowsHeader, subindex) in subSection.list">
                                    <v-span v-if="rowsHeader.dataType==2">{{rowsHeader.amount}}</v-span>
                                    <v-span label="Quantity" outlined
                                            v-else-if="rowsHeader.dataType==4">{{rowsHeader.amount}}</v-span>
                                    <v-span label="Quantity1" outlined
                                            v-else-if="rowsHeader.dataType==6">{{rowsHeader.amount}}</v-span>
                                    <v-span label="Total" outlined
                                            v-else-if="rowsHeader.dataType==5">{{rowsHeader.amount}}</v-span>
                                    <v-span label="Text" outlined v-else>{{rowsHeader.value}}</v-span>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b>कुल जम्मा</b></td>
                            <td :key="'totalindex'+index" v-for="(total,index) in totals">
                                <b v-if="total!=null">{{total.total}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>


            <!-----------------and------------------------->


            <div v-if="tableView && headers.length>0">

                <h2 style="text-align:center">{{valueShow}} आ.ब.{{showNextYear?YearPreviousCurrentNext.next:yearShow}}  को {{reportTitle}}</h2>
                <table class="table tbl">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th rowspan="2">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब.  {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, count) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->


                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, secondIndex) in colsHeaders">
                                <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->


                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                    v-if="header.groupID>0 ">

                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, subindex) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>

                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, innerindex) in column.subList">
                                            <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->

                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, index) in subColumns">
                                <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, interindex) in column.subList">
                                    <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->

                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>


                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>


                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b>कुल जम्मा</b></td>
                            <td :key="'totalindex'+index" v-for="(total,index) in totals">
                                <b v-if="total!=null">{{total.total}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <table class="table tbl" id="tblData" v-show="exportTbl">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th rowspan="2">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'firstrowthead'"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, count) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index+'firstrowtheadelse'+count">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, secondIndex) in colsHeaders">
                                <th :key="'secondheaderrow'+secondIndex" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>


                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" :key="index+'rowspan3ck'"
                                    v-if="header.groupID>0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END-->

                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, subindex) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            :key="index+'rowspan2rk'+subindex" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>

                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->

                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, innerindex) in column.subList">
                                            <th rowspan="3" style="text-align:center" :key="subindex+'subColumn2'+innerindex">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>

                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->
                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, index) in subColumns">
                                <th :colspan="column.subList.length" :key="'subColumn2las'+index" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                                    </span>
                                    <!--END NEW-->

                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, interindex) in column.subList">
                                    <th :key="index+'subColumn3wer'+interindex" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>

                                        <!--END NEW-->

                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="'subColumn4ask'+index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>


                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b>कुल जम्मा</b></td>
                            <td :key="'totalindex'+index" v-for="(total,index) in totals">
                                <b v-if="total!=null">{{total.total}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </div>
    </v-card>






    






</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'ApprovedComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },
        props: ['quarterbtnData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                snackbar: false,
                table: false,
                dialogCreate: false,
                breadCrumbs: [],
                IsActive: false,
                selectedRadio: null,
                TotalHeaderIndex: 0,
                showNextYear: false,
                isSaveable: false,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                helpData:[],
                logData: this.$route.query,
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: "",
                YearPreviousCurrentNext: {},
                groupedRows: [],
                color: "",
                currentFinalized: true,
                levellist:[],
                activeLevellist:[],
            };
        },
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
        },
        mounted() {
            this.getData();
        },

        methods: {
            dialogueClose() {
                this.dialog = true
                this.$emit("formResponse", this.dialog);
            },
            getData(){
                console.log("comphere", this.quarterbtnData)
                let levelData={
                    reportLogID: parseInt(this.quarterbtnData.reportLogID),
                }
                axios.post("ReportSettings/QuarterLevelByReportLog", levelData).then(response => {
                    this.levellist = response.data
                })
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })
                axios.post("ReportSettings/QuarterActiveLevelByReportLog", levelData).then(response => {
                    this.activeLevellist = response.data
                    console.log('kk', this.activeLevellist)
                    const updatableObject = this.activeLevellist.find(item => item.isUpdatable === true);
                    this.selectedRadio = updatableObject.level;
                })
            },

            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },


            nullTitle(title) {
                return title == null
            },

            branchData() {
                axios.get("Branch/DDLBranchList", {
                    params: {
                        companyID: this.logData.companyID
                    }
                }).then(response => {
                    this.listDDLData.branchList = response.data
                })
            },

            updateReportData() {
                var tableFormData = [];
                this.rows.forEach(function (data) {
                    data.list.forEach(function (list) {
                        list.list.forEach(function (amount) {
                        //    if (parseFloat(amount.amount) > 0 || (amount.value != "")) {
                                amount.amount = parseFloat(amount.amount);
                                tableFormData.push(amount);
                         //   }
                        })
                    })
                })
                let logData = {
                    "companyID": this.serverData.companyID,
                    "departmentID": this.serverData.departmentID,
                    "branchID": this.serverData.branchID,
                    "depoID": this.serverData.depoID,
                    "reportID": parseInt(this.serverData.reportID),
                    "levelID": parseInt(this.serverData.levelID),
                    "year": this.quarterbtnData.year,
                    "list": tableFormData,
                    "reportLogID": this.serverData.reportLogID == "" ? 0 : parseInt(this.serverData.reportLogID)
                }
                axios.post("ReportSettings/QuarterLevelInsertOrUpdateDataAsync", logData).then(response => {
                    if (response.data.success) {
                        this.logData.reportLogID = response.data.id;
                        this.status = "success"
                        this.color = "success"
                        this.snackbar = true
                        this.callbackResponse.message = "Data updated successfully."
                        this.reportLog()
                    }
                })
            },

            updateActiveLevel(newValue) {
                let logData = {
                    "companyID": 0,
                    "branchID": 0,
                    "depoID": 0,
                    "reportID": parseInt(this.quarterbtnData.reportID),
                    "level": parseInt(newValue),
                    "isUpdatable": true,
                    "reportLogID": this.quarterbtnData.reportLogID == "" ? 0 : parseInt(this.quarterbtnData.reportLogID)
                }
                axios.post("ReportSettings/UpdateActiveQuarterLevelByReportLog", logData).then(response => {
                    if (response.data.success) {
                        this.logData.reportLogID = response.data.id;
                        this.status = "success"
                        this.color = "success"
                        this.snackbar = true
                        this.callbackResponse.message = "Data updated successfully."
                        this.getData()
                    }
                })
            },
        
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.reportLog();
            },

            onPerPageChange(params) {
                this.serverParams.page = 1
                this.updateParams({perPage: params.currentPerPage});
                this.reportLog();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.reportLog();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.reportLog();
            },







            logBtnData(title, status, year) {
                console.log(title)
                this.isSaveable = title.isUpdatable
                this.logData.companyID = title.companyID
                this.logData.reportLogID = title.reportLogID
                this.helpData = title
                if (this.logData.companyID) {
                    this.getDdlData(this.logData.companyID, 'company');
                    this.logData.branchID = this.helpData.branchID
                    if (this.logData.branchID) {
                        this.getDdlData(this.logData.branchID, 'branch')
                        this.logData.depoID = this.helpData.depoID
                        if (this.logData.depoID) {
                            this.getDdlData(this.logData.depoID, 'depo')
                        }
                    }
                }

                this.logData.departmentID = this.helpData.departmentID
                this.logData.year = year
                if (title.departmentID > 0) {
                    this.valueShow = title.departmentName
                } else if (title.depoID > 0) {
                    this.valueShow = title.depoName
                } else if (title.branchID > 0) {
                    this.valueShow = title.branchName
                } else {
                    this.valueShow = title.companyName
                }
                this.yearShow = title.yearName
                var data = {
                    "reportLogID": parseInt(title.reportLogID),
                    "year": year,
                    "depoID": parseInt(title.depoID),
                    "branchID": parseInt(title.branchID),
                    "companyID": parseInt(title.companyID),
                    "levelID": parseInt(title.level),
                    "reportID": title.reportID
                }
                this.serverData = data;
                this.table = true
                this.getColsRow(this.serverData)
            },
            getDdlData(data, val) {

                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.branchID = 0
                    this.logData.depoID = 0
                    this.logData.departmentID = 0
                    formVal = {
                        companyID: this.logData.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.logData.depoID = ""
                    this.logData.departmentID = 0

                    formVal = {
                        branchID: this.logData.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.logData.departmentID = 0

                    formVal = {
                        depoID: this.logData.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },
            getColsRow(data) {
                const currentYearIndex = this.indexWhere(this.yearList, item => item.value === data.year)
                let previousThreeYearIndex = currentYearIndex - 3;
                let previousTwoYearIndex = currentYearIndex - 2;
                let previousYearIndex = currentYearIndex - 1;
                let nextYearIndex = currentYearIndex + 1;
                let previousCurrentNext = {};

                this.yearList.forEach(function (data, yearIndex) {


                    if (currentYearIndex == yearIndex) {
                        previousCurrentNext.current = data.id
                    }
                    //NEW
                    if (previousTwoYearIndex == yearIndex) {
                        previousCurrentNext.twoYear = data.id
                    }
                    if (previousThreeYearIndex == yearIndex) {
                        previousCurrentNext.threeYear = data.id
                    }
                    //end NEW
                    if (previousYearIndex == yearIndex) {
                        previousCurrentNext.previous = data.id
                    }
                    if (nextYearIndex == yearIndex) {
                        previousCurrentNext.next = data.id
                    }

                })
                data.depoID = this.quarterbtnData.depoID,
                    data.branchID = this.quarterbtnData.branchID,
                    data.companyID = this.quarterbtnData.companyID
                if (data.depoID == "") {
                    data.depoID = null
                }
                this.YearPreviousCurrentNext = previousCurrentNext;
                axios.post('ReportSettings/GetQuarterlyLevelColsRows', data).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.showNextYear = response.data.showNextYear;
                })
            },

            exportTableToExcel(tableID, filename = '', year, reportTitle) {
                var downloadLink;
                var dataType = 'application/vnd.ms-excel';
                var tableSelect = document.getElementById(tableID);
                var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

                // Specify file name
                filename = filename ? filename + year + '.xls' : 'reportForm.xls';

                // Prepend the report title to the filename
                filename = reportTitle + '_' + filename;

                // Create download link element
                downloadLink = document.createElement("a");

                document.body.appendChild(downloadLink);

                if (navigator.msSaveOrOpenBlob) {
                    var dynamicTitle = this.valueShow.replace(/ /g, '&nbsp;') + ' आ.ब. &nbsp;' + (this.showNextYear ? this.YearPreviousCurrentNext.next : this.yearShow) + '&nbsp; को &nbsp;' + reportTitle.replace(/ /g, '&nbsp;');

                    // Create a table header with the dynamic title
                    var headerHTML = '<thead><tr style="height: 30px;"><th colspan="COLSPAN_VALUE""><span class="dynamicTitle"><b>' + dynamicTitle + '</b></span></th></tr></thead>';

                    // Modify the table HTML to include the header
                    tableHTML = tableHTML.replace('<table', '<table>' + headerHTML);

                    // Get all the data cells in the table if 'dataCells' is not already defined
                    var dataCells = Array.from(tableSelect.getElementsByTagName('td'));

                    // Add borders to the data cells
                    for (let i = 0; i < dataCells.length; i++) {
                        dataCells[i].style.border = '1px solid black';
                    }

                    // Create a Blob with the table data
                    var blob = new Blob(['\ufeff', tableHTML], { type: dataType });
                    navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    dynamicTitle = this.valueShow.replace(/ /g, '&nbsp;') + ' आ.ब. &nbsp;' + (this.showNextYear ? this.YearPreviousCurrentNext.next : this.yearShow) + '&nbsp; को &nbsp;' + reportTitle.replace(/ /g, '&nbsp;');

                    // Modify the table HTML to include the header
                    tableHTML = '<table><thead><tr style="height: 30px;"><th colspan="COLSPAN_VALUE"><span class="dynamicTitle"><b>' + dynamicTitle + '</b></span></th></tr></thead>' + tableHTML + '</table>';
                    // Get all the data cells in the table if 'dataCells' is not already defined
                    let dataCells = Array.from(tableSelect.getElementsByTagName('td'));

                    // Add borders to the data cells
                    for (let i = 0; i < dataCells.length; i++) {
                        dataCells[i].style.border = '1px solid black';
                    }


                    // Create a link to the file
                    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                    // Setting the file name
                    downloadLink.download = filename;

                    // Trigger the download by programmatically clicking the link
                    downloadLink.click();
                }
            },



        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;

    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;
    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
    .custom-radio {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s, color 0.3s, border-color 0.3s;
    }

    .custom-radio label {
        font-size: 16px;
        color: #333;
        margin-left: 10px;
    }

    .custom-radio input[type="radio"] {
        display: none;
    }

    .custom-radio input[type="radio"] + label:before {
        content: "";
        display: inline-block;
        width: 18px;
        height: 18px;
        border: 2px solid #ccc;
        border-radius: 50%;
        margin-right: 8px;
        transition: background-color 0.3s, border-color 0.3s;
    }

    .custom-radio input[type="radio"]:checked + label:before {
        border-color: #1976D2;
        background-color: #1976D2;
    }

    .custom-radio input[type="radio"]:checked + label {
        color: #1976D2;
        font-weight: bold;
    }

    /* Hover effect */
    .custom-radio input[type="radio"] + label:hover {
        background-color: #f5f5f5;
    }

    /* Focus effect */
    .custom-radio input[type="radio"]:focus + label:before {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    }
</style>
